<template>
  <aside id="subscribe-popup">
    <transition name="popup">
      <div class="subscribe-popup__body" v-show="visible">
        <close-icon @click="visible = false"></close-icon>
        <subscribe-form @submit="visible = false"></subscribe-form>  
      </div>
    </transition>
    <!-- <div class="subscribe-popup__barrier" v-show="visible" @click="visible = false"></div>-->
  </aside>
</template>

<script>
import CloseIcon from './IconClose'
import SubscribeForm from './SubscribeForm'
export default {
  name: 'SubscribePopUp',
  props: ['ready'],
  components: { SubscribeForm, CloseIcon },
  data () {
    return {
      visible: false,
      unwatch: null
    }
  },
  computed: {
    enabled () {
      const site = this.$store.state.site
      const field = site && site.data ? site.data['site.popup_subscribe_enabled'] : false
      return field && field.value === 'true'
    }
  },
  methods: {
    reveal () {
      setTimeout(() => {
        this.visible = true
        this.unwatch()
      }, 12000)
    }
  },
  mounted () {
    this.unwatch = this.$watch('enabled', () => {
      if (this.ready) return this.reveal()
      this.unwatch = this.$watch('ready', this.reveal)
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

.popup-enter-active,
.popup-leave-active{
  transition:all 600ms;
}
.popup-enter,
.popup-leave-to{
  opacity: 0;
  transform:translateY(12.5%);
}

aside{
  background-color:inherit;
}

.subscribe-popup__body{
  filter: invert(1);
  background-color:rgba($black, .87);
  color:$white;
  [data-theme="dark"] &{
    background-color:rgba($white, .87);
    color:$black;
  }
  position: fixed;
  z-index:$z-popup;
  bottom:0;
  // left:0;
  right: 0;
  // padding:(60/16*1em) $gutter (50/16*1em);
  padding:(48/16*1em) 3rem (28/16*1em);
  > *{
    max-width:29.8125em;
    margin:0 auto;
  }
}

/*
.subscribe-popup__barrier{
  position: fixed;
  top:0; left:0; width:100%; height:100%;
  z-index:$z-popup - 1;
}
*/

button{
  position: absolute;
  top:$gutter; right:$gutter;
  z-index:2;
}

@include on_mobile{
  aside > .subscribe-popup__body{
    padding-left:$gutter*2;
    padding-right:$gutter*2;
    @media (orientation:landscape){
      padding-top:$gutter*3;
      padding-bottom:$gutter;
    }
  }
}

@include on_mobile {
  .subscribe-popup__body {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// SubscribePopUp.vue?04442567